import { uploadUrl } from './config';
import { markUploaded } from './assetCloud';

/** Background upload: presign -> PUT bytes -> mark cloud-resolvable. Throws on failure (caller keeps the local objectURL). */
export async function uploadAsset(id: string, bytes: ArrayBuffer, contentType: string): Promise<void> {
  const presignRes = await fetch(uploadUrl(), {
    method: 'POST', headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ id, contentType }),
  });
  if (!presignRes.ok) throw new Error(`presign failed: ${presignRes.status}`);
  const { url } = (await presignRes.json()) as { id: string; url: string };
  const put = await fetch(url, { method: 'PUT', headers: { 'content-type': contentType }, body: bytes });
  if (!put.ok) throw new Error(`upload PUT failed: ${put.status}`);
  markUploaded(id);
}
